




















import Vue from 'vue';
import CtrlMessageDialog from './CtrlMessageDialog.vue';

export default Vue.extend({
  components: {
    CtrlMessageDialog,
  },
  name: 'NormalButton',
  props: {
    label: {
      type: String,
      default: '',
    },
    btnColor: {
      type: String,
      default: '',
    },
    messageShow: {
      type: Boolean,
      default: false,
    },
    messageId: {
      type: String,
      default: '',
    },
    messageTextParam: {
      type: Array,
    },
  },
  data: () => ({
    show: false,
  }),
  methods: {
    handleClick() {
      if (this.$el.classList.contains('disabled-btn')) return;
      if (this.messageShow) {
        this.show = true;
      } else {
        if (!this.$el.classList.contains('disabled-btn')) {
          this.$emit('click');
        }
      }
    },
    handleOk() {
      if (!this.messageShow) return;
      if (!this.$el.classList.contains('disabled-btn')) {
        this.$emit('ok');
      }
    },
    handleCancel() {
      if (!this.messageShow) return;
      if (!this.$el.classList.contains('disabled-btn')) {
        this.$emit('cancel');
      }
    },
  },
});
